
export const getTopTrendsData = (uri, env='prod', start='', end='') => {
    let qstr = '?';

    if (env && env != 'prod') {
        qstr += 'env=' + env;
    } else {
        qstr += 'env=prod';
    }

    if (start && end) {
        qstr += '&start=' + start + '&end=' + end;
    }

    const url = uri + qstr;

    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.open('GET', url);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                
                const data = JSON.parse(xhr.response);
                resolve(data);

            } else {
                console.log('Failed to fetch trends data');
            }
        };
        xhr.onerror = () => {
            console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
        };
        xhr.send();
    });
}
